import {AuthAbstractService} from 'sigale-angular';
import {UtilisateurSigalett} from '../models/utilisateur-sigalett.model';
import {Injectable} from '@angular/core';
import {JwtHelperService} from '@auth0/angular-jwt';
import {UtilisateurSigalettBuilder} from '../models/utilisateur-sigalett-builder';

@Injectable()
export class AuthService extends AuthAbstractService<UtilisateurSigalett> {

	constructor(jwtHelperService: JwtHelperService) {
		super(jwtHelperService);
	}

	private langueUtilisateurFrontend: string;

	construireUtilisateurDepuisToken(token: any): UtilisateurSigalett {
		const utilisateurBuilder: UtilisateurSigalettBuilder = new UtilisateurSigalettBuilder();
		return utilisateurBuilder
			.setLogin(token.sub)
			.setFirstName(token.firstName)
			.setLastName(token.lastName)
			.setRoles(token.rolesValues)
			.setDroits(token.droits)
			.setLangue(token.langue)
			.build();
	}

	mettreAJourLangueUtilisateurFrontend(langue: string) {
		this.langueUtilisateurFrontend = langue;
	}

	getLangueUtilisateurFrontend() {
		return this.langueUtilisateurFrontend;
	}
}
